"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Common_1 = require("../Common");
var Select_1 = require("../Select");
var PageTurnOptions_1 = __importDefault(require("./PageTurnOptions"));
var PagingContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n"])));
var PageNumberSelect = (0, styled_components_1.default)(Select_1.Select)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-left: 5px;\n\t& > div:first-child > div:first-child {\n\t\tmargin: 0 8px;\n\t\tfont-weight: ", ";\n\t}\n\ti {\n\t\tfont-size: 8px;\n\t}\n\t.tws-option-item > div {\n\t\tfont-size: 11px;\n\t\tfont-weight: ", ";\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\twidth: auto;\n\t\t.tws-select-dropdown-container {\n\t\t\twidth: auto;\n\t\t}\n\t\t& > div:first-child > div:last-child {\n\t\t\tpadding: 3px 7px;\n\t\t}\n\t}\n"], ["\n\tmargin-left: 5px;\n\t& > div:first-child > div:first-child {\n\t\tmargin: 0 8px;\n\t\tfont-weight: ", ";\n\t}\n\ti {\n\t\tfont-size: 8px;\n\t}\n\t.tws-option-item > div {\n\t\tfont-size: 11px;\n\t\tfont-weight: ", ";\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\twidth: auto;\n\t\t.tws-select-dropdown-container {\n\t\t\twidth: auto;\n\t\t}\n\t\t& > div:first-child > div:last-child {\n\t\t\tpadding: 3px 7px;\n\t\t}\n\t}\n"])), globalVars_module_scss_1.default.fontWeightThick, globalVars_module_scss_1.default.fontWeightThick);
PageNumberSelect.displayName = 'PageNumberSelect';
var PageSizeSelect = (0, styled_components_1.default)(Select_1.Select)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin-left: 7px;\n\t& > div:first-child > div:first-child {\n\t\tmargin: 0 8px;\n\t\tfont-weight: ", ";\n\t}\n\ti {\n\t\tfont-size: 8px;\n\t}\n\t.tws-option-item > div {\n\t\tfont-size: 11px;\n\t\tfont-weight: ", ";\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tdisplay: none !important;\n\t}\n"], ["\n\tmargin-left: 7px;\n\t& > div:first-child > div:first-child {\n\t\tmargin: 0 8px;\n\t\tfont-weight: ", ";\n\t}\n\ti {\n\t\tfont-size: 8px;\n\t}\n\t.tws-option-item > div {\n\t\tfont-size: 11px;\n\t\tfont-weight: ", ";\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tdisplay: none !important;\n\t}\n"])), globalVars_module_scss_1.default.fontWeightThick, globalVars_module_scss_1.default.fontWeightThick);
PageSizeSelect.displayName = 'PageSizeSelect';
var RecordTotal = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\ti {\n\t\tfont-size: 16px;\n\t\tvertical-align: middle;\n\t\tmargin-right: ", ";\n\t\tmargin-left: ", ";\n\t\twidth: 16px;\n\t}\n\tspan {\n\t\tfont-size: 11px;\n\t\tcolor: ", ";\n\t\tfont-weight: ", ";\n\t\tline-height: 11px;\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\ti {\n\t\t\tfont-size: 19px;\n\t\t\twidth: 19px;\n\t\t}\n\t\tspan {\n\t\t\tfont-size: 12px;\n\t\t}\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\ti {\n\t\tfont-size: 16px;\n\t\tvertical-align: middle;\n\t\tmargin-right: ", ";\n\t\tmargin-left: ", ";\n\t\twidth: 16px;\n\t}\n\tspan {\n\t\tfont-size: 11px;\n\t\tcolor: ", ";\n\t\tfont-weight: ", ";\n\t\tline-height: 11px;\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\ti {\n\t\t\tfont-size: 19px;\n\t\t\twidth: 19px;\n\t\t}\n\t\tspan {\n\t\t\tfont-size: 12px;\n\t\t}\n\t}\n"])), globalVars_module_scss_1.default.spacing5, globalVars_module_scss_1.default.spacing10, globalVars_module_scss_1.default.mainGray, globalVars_module_scss_1.default.fontWeightThick);
RecordTotal.displayName = 'RecordTotal';
var PagingOptions = /** @class */ (function (_super) {
    __extends(PagingOptions, _super);
    function PagingOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.setPageNumber = _this.setPageNumber.bind(_this);
        _this.setPageSize = _this.setPageSize.bind(_this);
        _this.pageNumberSelectDisabled = _this.pageNumberSelectDisabled.bind(_this);
        _this.getPageNumber = _this.getPageNumber.bind(_this);
        _this.handlePageNumberChange = _this.handlePageNumberChange.bind(_this);
        _this.handlePageSizeChange = _this.handlePageSizeChange.bind(_this);
        return _this;
    }
    PagingOptions.prototype.setPageNumber = function (page) {
        var offset = (page - 1) * this.props.pageRange.limit;
        this.props.updatePageRange(__assign(__assign({}, this.props.pageRange), { offset: offset }));
    };
    PagingOptions.prototype.setPageSize = function (size) {
        this.props.updatePageRange(__assign(__assign({}, this.props.pageRange), { limit: size, offset: 0 }));
    };
    PagingOptions.prototype.getPageOptions = function () {
        var pageSelectOptions = [];
        var totalPages = this.props.pageRange.total ? Math.ceil(this.props.pageRange.total / this.props.pageRange.limit) : 1;
        for (var i = 1; i <= totalPages; i++) {
            pageSelectOptions.push({ name: i.toString(), displayText: "".concat(i, "/").concat(totalPages), disabled: false });
        }
        return pageSelectOptions;
    };
    PagingOptions.prototype.getPageSizeOptions = function () {
        var pageSizeOptions = [10, 25, 50, 100, 200];
        return pageSizeOptions.map(function (value) {
            return { name: value.toString(), displayText: value.toString(), disabled: false };
        });
    };
    PagingOptions.prototype.pageNumberSelectDisabled = function () {
        return !this.props.pageRange.total || this.props.pageRange.total <= this.props.pageRange.limit;
    };
    PagingOptions.prototype.pageSizeSelectDisabled = function () {
        return !this.props.pageRange.total || this.props.pageRange.total <= 10;
    };
    PagingOptions.prototype.getPageNumber = function () {
        return (Math.ceil(this.props.pageRange.offset / this.props.pageRange.limit) + 1).toString();
    };
    PagingOptions.prototype.handlePageSizeChange = function (value) {
        this.setPageSize(parseInt(value, 10));
    };
    PagingOptions.prototype.handlePageNumberChange = function (value) {
        this.setPageNumber(parseInt(value, 10));
    };
    PagingOptions.prototype.render = function () {
        return (React.createElement(PagingContainer, { className: 'tws-paging-container' },
            React.createElement(PageTurnOptions_1.default, __assign({}, this.props)),
            React.createElement(PageNumberSelect, { items: this.getPageOptions(), selectedValue: this.getPageNumber(), onApply: this.handlePageNumberChange, disabled: this.pageNumberSelectDisabled(), className: 'tws-paging-page-number-select', size: 'xs' }),
            React.createElement(PageSizeSelect, { items: this.getPageSizeOptions(), selectedValue: this.props.pageRange.limit.toString(), onApply: this.handlePageSizeChange, disabled: this.pageSizeSelectDisabled(), className: 'tws-paging-page-size-select', size: 'xs' }),
            React.createElement(RecordTotal, { className: 'tws-paging-total-record-count' },
                React.createElement(Common_1.Icon, { name: 'total' }),
                React.createElement("span", { className: 'totalRecordsCount', "aria-hidden": true }, this.props.pageRange.total),
                this.props.pageRange.total !== undefined && React.createElement("span", { className: 'sr-only' }, "".concat(this.props.pageRange.total, " records in table")))));
    };
    return PagingOptions;
}(React.PureComponent));
exports.default = PagingOptions;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
